class BlockRange {

	constructor(){

		let blocks = document.querySelectorAll('.block-range');

		blocks.forEach( (block) => {

			let ranges = document.querySelectorAll('.range-teaser');

			ranges.forEach( (range) => {

				let slider = range.querySelector('.swiper');
				let navigation = range.querySelectorAll('.switch-power span');
				let sliderText = range.querySelector('.swiper-text');

				let swiper = new Swiper(slider, {
					speed: 300,
					allowTouchMove: false,
					slidesPerView: 1,
					effect: 'creative',
					creativeEffect: {
						prev: {
							// will set `translateZ(-400px)` on previous slides
							translate: [0, -25, -100],
							opacity: 0
						},
						next: {
							// will set `translateX(100%)` on next slides
							translate: [0, 25, -100],
							opacity: 0
						},
					},
				});

				let swiperText = new Swiper(sliderText, {
					speed: 500,
					allowTouchMove: false,
					slidesPerView: 1,
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					}
				});

				swiper.controller.control = swiperText;

				navigation.forEach( (nav, i) => {
					nav.addEventListener( 'click', () => {
						swiper.slideTo(i);
						navigation.forEach((el) => {
							el.classList.remove('current');
						});
						nav.classList.add('current');
					});
				});

			});

		});

	}

}
